{
  "PROFILE_SETTINGS": {
    "LINK": "Configurações do Perfil",
    "TITLE": "Configurações do Perfil",
    "BTN_TEXT": "Atualizar o Perfil",
    "DELETE_AVATAR": "Apagar Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar apagado com sucesso",
    "AVATAR_DELETE_FAILED": "Ocorreu um erro ao excluir o avatar. Tente novamente",
    "UPDATE_SUCCESS": "Seu perfil foi atualizado com sucesso",
    "PASSWORD_UPDATE_SUCCESS": "A sua senha foi alterada com sucesso",
    "AFTER_EMAIL_CHANGED": "Seu perfil foi atualizado com sucesso. Faça login novamente, pois suas credenciais de login foram alteradas",
    "FORM": {
      "PICTURE": "Foto do perfil",
      "AVATAR": "Imagem de Perfil",
      "ERROR": "Por favor, corrija os erros",
      "REMOVE_IMAGE": "Excluir",
      "UPLOAD_IMAGE": "Carregar imagem",
      "UPDATE_IMAGE": "Atualizar Imagem",
      "PROFILE_SECTION": {
        "TITLE": "Perfil",
        "NOTE": "Seu endereço de e-mail é sua identidade e é usado para fazer login."
      },
      "SEND_MESSAGE": {
        "TITLE": "Tecla de atalho para enviar mensagens",
        "NOTE": "Você pode selecionar uma tecla de atalho (Enter ou Cmd/Ctrl+Enter) com base na sua preferência de escrita.",
        "UPDATE_SUCCESS": "Suas configurações foram atualizadas com sucesso",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Enviar mensagens pressionando a tecla Enter em vez de clicar no botão de enviar."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Pressione a tecla Cmd/Ctrl + Enter ao invés de clicar no botão enviar."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Personalize a aparência do seu painel do Chatwoot.",
        "FONT_SIZE": {
          "TITLE": "Tamanho da fonte",
          "NOTE": "Ajuste o tamanho do texto do painel com base na sua preferência.",
          "UPDATE_SUCCESS": "As configurações de sua fonte foram atualizadas com sucesso",
          "UPDATE_ERROR": "Ocorreu um erro ao atualizar as configurações de fonte, por favor, tente novamente",
          "OPTIONS": {
            "SMALLER": "Menor",
            "SMALL": "Pequeno",
            "DEFAULT": "Padrão",
            "LARGE": "Grande",
            "LARGER": "Maior",
            "EXTRA_LARGE": "Muito Grande"
          }
        },
        "LANGUAGE": {
          "TITLE": "Idioma preferido",
          "NOTE": "Escolha o idioma que deseja usar.",
          "UPDATE_SUCCESS": "Suas configurações de idioma foram atualizadas com sucesso",
          "UPDATE_ERROR": "Ocorreu um erro ao atualizar as configurações de idioma, por favor, tente novamente",
          "USE_ACCOUNT_DEFAULT": "Usar padrão da conta"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Assinatura de mensagens pessoais",
        "NOTE": "Crie uma assinatura de mensagem única para aparecer no final de cada mensagem que você enviar de qualquer caixa de entrada. Você também pode incluir uma imagem anexada, suportada em live-chat, e-mail e caixas de entrada de API.",
        "BTN_TEXT": "Salvar assinatura da mensagem",
        "API_ERROR": "Não foi possível salvar a assinatura! Tente novamente",
        "API_SUCCESS": "Assinatura salva com sucesso",
        "IMAGE_UPLOAD_ERROR": "Não foi possível fazer o upload da imagem! Tente novamente",
        "IMAGE_UPLOAD_SUCCESS": "Imagem adicionada com sucesso. Por favor clique em salvar para salvar a assinatura",
        "IMAGE_UPLOAD_SIZE_ERROR": "O tamanho da imagem deve ser menor que {size}MB",
        "INLINE_IMAGE_WARNING": "Imagens incorporadas coladas foram removidas. Por favor, use o botão enviar imagem para adicionar imagens à sua assinatura."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Assinatura da mensagem",
        "ERROR": "Assinatura da mensagem não pode estar vazia",
        "PLACEHOLDER": "Insira aqui a assinatura de sua mensagem pessoal."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Senha",
        "NOTE": "A atualização da sua senha redefiniria o seu login em vários dispositivos.",
        "BTN_TEXT": "Mudar Senha"
      },
      "SECURITY_SECTION": {
        "TITLE": "Segurança",
        "NOTE": "Gerencie recursos adicionais de segurança para sua conta.",
        "MFA_BUTTON": "Gerenciar autenticação de dois fatores "
      },
      "SESSIONS_SECTION": {
        "TITLE": "Sessões ativas",
        "NOTE": "Estes são os dispositivos atualmente conectados à sua conta.",
        "CURRENT": "Sessão atual",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Sessão revogada com sucesso",
        "REVOKE_ERROR": "Não foi possível revogar a sessão. Por favor, tente novamente.",
        "FETCH_ERROR": "Não foi possível realizar a sessão. Por favor, tente novamente.",
        "LAST_ACTIVE": "Última atividade em",
        "UNKNOWN_DEVICE": "Dispositivo desconhecido"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token de acesso",
        "NOTE": "Esse token pode ser usado se você estiver criando uma integração baseada em API",
        "PAID_PLAN_NOTE": "Tokens de acesso API estão disponíveis em planos pagos.",
        "COPY": "Copiar",
        "RESET": "Reiniciar",
        "CONFIRM_RESET": "Você tem certeza?",
        "CONFIRM_HINT": "Clique novamente para confirmar",
        "RESET_SUCCESS": "Token de acesso gerado novamente com sucesso",
        "RESET_ERROR": "Não foi possível regerar o token de acesso. Por favor, tente novamente"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Alertas de áudio",
        "NOTE": "Habilitar notificações de áudio no painel para novas mensagens e conversas.",
        "PLAY": "Reproduzir áudio",
        "ALERT_TYPES": {
          "NONE": "Nenhuma",
          "MINE": "Atribuído",
          "ALL": "Todos",
          "ASSIGNED": "Conversas atribuídas a mim",
          "UNASSIGNED": "Conversas não atribuídas",
          "NOTME": "Conversas abertas atribuídas a outras pessoas"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Você não selecionou nenhuma opção, você não receberá nenhum alerta de áudio.",
          "ASSIGNED": "Você receberá alertas para conversas atribuídas a você.",
          "UNASSIGNED": "Você receberá alertas para quaisquer conversas não atribuídas.",
          "NOTME": "Você receberá alertas para conversas atribuídas a outras pessoas.",
          "ASSIGNED+UNASSIGNED": "Receberá alertas de conversas atribuídas e de quaisquer conversas não atendidas.",
          "ASSIGNED+NOTME": "Você receberá alertas para conversas atribuídas a você e a outros, mas não para conversas não atribuídas.",
          "NOTME+UNASSIGNED": "Você receberá alertas de conversas não atendidas e aquelas atribuídas a outros.",
          "ASSIGNED+NOTME+UNASSIGNED": "Você receberá alertas para quaisquer conversas não atribuídas."
        },
        "ALERT_TYPE": {
          "TITLE": "Eventos de alerta para conversas",
          "NONE": "Nenhuma",
          "ASSIGNED": "Conversas atribuídas",
          "ALL_CONVERSATIONS": "Todas as conversas"
        },
        "DEFAULT_TONE": {
          "TITLE": "Titulo:"
        },
        "CONDITIONS": {
          "TITLE": "Condições:",
          "CONDITION_ONE": "Enviar alertas de áudio apenas se a janela do navegador não estiver ativa",
          "CONDITION_TWO": "Enviar alertas a cada 30 segundos até que todas as conversas atribuídas sejam lidas"
        },
        "SOUND_PERMISSION_ERROR": "A reprodução automática está desativada no seu navegador. Para ouvir alertas automaticamente, habilite a permissão de som nas configurações do seu navegador ou interaja com a página.",
        "READ_MORE": "Saiba mais"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificações por e-mail",
        "NOTE": "Atualize suas preferências de notificação por e-mail aqui",
        "CONVERSATION_ASSIGNMENT": "Enviar notificações por email quando uma conversa for atribuída a mim",
        "CONVERSATION_CREATION": "Enviar notificações por email quando uma nova conversa for criada",
        "CONVERSATION_MENTION": "Enviar notificações por email quando você for mencionado em uma conversa",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envie notificações por e-mail quando uma nova mensagem for criada numa conversa já atribuída",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificações por email quando uma nova mensagem é criada em uma conversa que você participa",
        "SLA_MISSED_FIRST_RESPONSE": "Enviar notificações por e-mail quando uma conversa perder a primeira resposta SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Enviar notificações por e-mail quando uma conversa perder o próximo SLA de resposta",
        "SLA_MISSED_RESOLUTION": "Enviar notificações por e-mail quando uma conversa perder o SLA de resolução"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferências de notificação",
        "TYPE_TITLE": "Tipo de notificação",
        "EMAIL": "E-mail",
        "PUSH": "Notificação ",
        "TYPES": {
          "CONVERSATION_CREATED": "Uma nova conversa foi criada",
          "CONVERSATION_ASSIGNED": "Uma conversa foi atribuída a você",
          "CONVERSATION_MENTION": "Você foi mencionado em uma conversa",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Uma nova mensagem foi criada e atribuída",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Uma nova mensagem foi criada em uma conversa que você participa",
          "SLA_MISSED_FIRST_RESPONSE": "Uma conversa perde o SLA de primeira resposta",
          "SLA_MISSED_NEXT_RESPONSE": "Uma conversa perde o SLA da próxima resposta",
          "SLA_MISSED_RESOLUTION": "Uma conversa perde o SLA de resolução"
        },
        "BROWSER_PERMISSION": "Ative notificações push em seu navegador para poder recebê-las"
      },
      "API": {
        "UPDATE_SUCCESS": "Suas preferências de notificação foram atualizadas com sucesso",
        "UPDATE_ERROR": "Ocorreu um erro ao atualizar as preferências, por favor, tente novamente"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Notificações via Push",
        "NOTE": "Atualize suas preferências de notificação Push aqui",
        "CONVERSATION_ASSIGNMENT": "Enviar notificações push quando uma conversa é atribuída a mim",
        "CONVERSATION_CREATION": "Enviar notificações push quando uma nova conversa é criada",
        "CONVERSATION_MENTION": "Enviar notificações push quando você for mencionado em uma conversa",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Envie notificações quando uma nova mensagem for criada numa conversa já atribuída",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Enviar notificações push quando uma nova mensagem é criada em uma conversa que você participa",
        "HAS_ENABLED_PUSH": "Você ativou push para este navegador.",
        "REQUEST_PUSH": "Habilitar notificações push",
        "SLA_MISSED_FIRST_RESPONSE": "Enviar notificações quando uma conversa perder a primeira resposta SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Enviar notificações quando uma conversa perder a próxima resposta SLA",
        "SLA_MISSED_RESOLUTION": "Enviar notificações quando uma conversa perder resolução de resolução SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Imagem do Perfil"
      },
      "NAME": {
        "LABEL": "Seu nome completo",
        "ERROR": "Por favor, insira um nome completo válido",
        "PLACEHOLDER": "Por favor, digite seu nome completo"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nome para exibição",
        "ERROR": "Por favor, insira um nome de exibição válido",
        "PLACEHOLDER": "Por favor, insira um nome de exibição para ser exibido em conversas"
      },
      "AVAILABILITY": {
        "LABEL": "Disponibilidade",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Ocupado",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Disponibilidade foi definida com sucesso",
        "SET_AVAILABILITY_ERROR": "Não foi possível definir a disponibilidade, por favor tente novamente",
        "IMPERSONATING_ERROR": "Não é possível alterar a disponibilidade enquanto personifica um usuário"
      },
      "EMAIL": {
        "LABEL": "Seu e-mail",
        "ERROR": "Por favor, insira um endereço de e-mail válido",
        "PLACEHOLDER": "Por favor, insira seu endereço de e-mail, que será exibido em conversas"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Senha atual",
        "ERROR": "Por favor, digite a senha atual",
        "PLACEHOLDER": "Por favor, digite a senha atual"
      },
      "PASSWORD": {
        "LABEL": "Nova senha",
        "ERROR": "Por favor, digite uma senha de comprimento 6 ou mais",
        "PLACEHOLDER": "Por favor, digite uma nova senha"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Confirme a nova senha",
        "ERROR": "A confirmação da senha é diferente. Favor digitar novamente",
        "PLACEHOLDER": "Por favor, digite sua nova senha "
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Trocar",
    "CHANGE_ACCOUNTS": "Alterar conta",
    "SWITCH_ACCOUNT": "Alterar conta",
    "CONTACT_SUPPORT": "Contate o suporte",
    "SELECTOR_SUBTITLE": "Selecione uma conta da lista a seguir",
    "PROFILE_SETTINGS": "Configurações do Perfil",
    "YEAR_IN_REVIEW": "Retrospectiva do Ano",
    "KEYBOARD_SHORTCUTS": "Atalhos do teclado",
    "APPEARANCE": "Alterar Tema",
    "SUPER_ADMIN_CONSOLE": "Console de Super Admin",
    "DOCS": "Ler documentação",
    "CHANGELOG": "Notas de versão",
    "LOGOUT": "Encerrar sessão"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dias de teste restantes.",
    "TRAIL_BUTTON": "Comprar agora",
    "DELETED_USER": "Deletar Usuário",
    "EMAIL_VERIFICATION_PENDING": "Parece que você ainda não verificou seu endereço de e-mail. Por favor, verifique sua caixa de entrada pelo e-mail de verificação.",
    "RESEND_VERIFICATION_MAIL": "Reenviar e-mail de verificação",
    "EMAIL_VERIFICATION_SENT": "O e-mail de verificação foi enviado. Por favor, verifique sua caixa de entrada.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Conta Suspensa",
      "MESSAGE": "Sua conta está suspensa. Entre em contato com a equipe de suporte para obter mais informações."
    },
    "NO_ACCOUNTS": {
      "TITLE": "Nenhuma conta encontrada",
      "MESSAGE_CLOUD": "Você não faz parte de nenhuma conta no momento. Se acreditar que isso é um engano, entre em contato com nossa equipe de suporte.",
      "MESSAGE_SELF_HOSTED": "Você não faz parte de nenhuma conta no momento. Entre em contato com o seu administrador.",
      "LOGOUT": "Encerrar sessão"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Copiar",
      "CODEPEN": "Abrir em CodePen",
      "COPY_SUCCESSFUL": "Código copiado para área de transferência com sucesso"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Mostrar Mais",
      "SHOW_LESS": "Mostrar Menos"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Baixar",
      "UPLOADING": "Enviando...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Este story não está mais disponível.",
      "INSTAGRAM_STORY_REPLY": "Respondido ao seu story:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Ver Localização"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Enviar"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Esta imagem não está mais disponível.",
      "LOADING_FAILED": "Falha no carregamento"
    }
  },
  "CONFIRM_EMAIL": "Verificando...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Adicionar Caixa de Entrada"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Nenhum item",
    "CURRENTLY_VIEWING_ACCOUNT": "Visualização atual:",
    "SWITCH": "Trocar",
    "INBOX_VIEW": "Caixa de entrada",
    "CONVERSATIONS": "Conversas",
    "INBOX": "Caixa de Entrada",
    "ALL_CONVERSATIONS": "Todas as conversas",
    "MENTIONED_CONVERSATIONS": "Menções",
    "PARTICIPATING_CONVERSATIONS": "Participantes",
    "UNATTENDED_CONVERSATIONS": "Não atendidas",
    "REPORTS": "Relatórios",
    "SETTINGS": "Configurações",
    "CONTACTS": "Contatos",
    "ACTIVE": "Ativo",
    "COMPANIES": "Empresas",
    "ALL_COMPANIES": "Todas as empresas",
    "CAPTAIN": "Capitão",
    "CAPTAIN_ASSISTANTS": "Assistentes",
    "CAPTAIN_OVERVIEW": "Visão geral",
    "CAPTAIN_DOCUMENTS": "Documentos",
    "CAPTAIN_RESPONSES": "FAQs",
    "CAPTAIN_TOOLS": "Ferramentas",
    "CAPTAIN_SCENARIOS": "Cenários",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Caixas de Entrada",
    "CAPTAIN_SETTINGS": "Configurações",
    "HOME": "Principal",
    "AGENTS": "Agentes",
    "AGENT_BOTS": "Robôs",
    "AUDIT_LOGS": "Auditoria",
    "INBOXES": "Caixas de Entrada",
    "NOTIFICATIONS": "Notificações",
    "CANNED_RESPONSES": "Respostas Prontas",
    "INTEGRATIONS": "Integrações",
    "DATA": "Dado",
    "PROFILE_SETTINGS": "Configurações do Perfil",
    "ACCOUNT_SETTINGS": "Conta",
    "APPLICATIONS": "Aplicações",
    "LABELS": "Etiquetas",
    "CUSTOM_ATTRIBUTES": "Atributos Personalizados",
    "AUTOMATION": "Automação",
    "MACROS": "Macros",
    "TEAMS": "Times",
    "BILLING": "Cobrança",
    "CUSTOM_VIEWS_FOLDER": "Pastas",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentos",
    "ALL_CONTACTS": "Todos os Contatos",
    "TAGGED_WITH": "Marcado com",
    "NEW_LABEL": "Nova etiqueta",
    "NEW_TEAM": "Novo time",
    "NEW_INBOX": "Nova caixa de entrada",
    "REPORTS_CONVERSATION": "Conversas",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Chat ao vivo",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Campanhas",
    "ONGOING": "Em andamento",
    "ONE_OFF": "Única",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Robôs",
    "REPORTS_AGENT": "Agentes",
    "REPORTS_LABEL": "Etiquetas",
    "REPORTS_INBOX": "Caixa de Entrada",
    "REPORTS_TEAM": "Time",
    "AGENT_ASSIGNMENT": "Atribuição de Agentes",
    "SET_AVAILABILITY_TITLE": "Defina como",
    "SET_YOUR_AVAILABILITY": "Disponibilidade",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Funções Personalizadas",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Visão geral",
    "REAUTHORIZE": "A conexão com a sua caixa de entrada expirou. Por favor, reconecte para continuar recebendo e enviando mensagens",
    "HELP_CENTER": {
      "TITLE": "Central de Ajuda",
      "ARTICLES": "Artigos",
      "CATEGORIES": "Categorias",
      "LOCALES": "Localidades",
      "SETTINGS": "Configurações"
    },
    "CHANNELS": "Canais",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Marcar offline automaticamente",
      "INFO_TEXT": "Deixe o sistema marcar você automaticamente quando você não estiver usando o app ou o painel de controle.",
      "INFO_SHORT": "Marcar off-line automaticamente quando não estiver usando o aplicativo."
    },
    "SORT_TOOLTIP": "Ordenar",
    "SORT_BY": "Classificar por",
    "SORT_GROUPS": {
      "CREATED": "Ordenar por data de criação",
      "ALPHABETICAL": "Ordenar em ordem alfabética",
      "UNREAD_COUNT": "Classificar por contagem não lida"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Mais recentes primeiro",
      "CREATED_ASC": "Mais antigos primeiro",
      "ALPHABETICAL_ASC": "Ascendente (A - Z)",
      "ALPHABETICAL_DESC": "Descendente (Z - A)",
      "UNREAD_COUNT_DESC": "Mais alto primeiro",
      "UNREAD_COUNT_ASC": "Mais baixo primeiro"
    },
    "DOCS": "Ler documentos",
    "SECURITY": "Segurança",
    "CAPTAIN_AI": "Capitão",
    "CONVERSATION_WORKFLOW": "Fluxo de Conversa"
  },
  "DATA_IMPORTS": {
    "HEADER": "Dado",
    "DESCRIPTION": "Trazer seus contatos e conversas anteriores para esta conta de outra ferramenta de suporte. Cada importação é executada em segundo plano, então você pode continuar funcionando enquanto ela termina, acompanhar o seu progresso e rever tudo o que foi ignorado ao longo do caminho.",
    "LOADING": "Buscando importações",
    "DEFAULT_IMPORT_NAME": "Importação Intercom",
    "TABS": {
      "IMPORT": "Importar",
      "EXPORT": "Exportar"
    },
    "TYPES": {
      "CONTACTS": "Contatos",
      "CONVERSATIONS": "Conversas",
      "MESSAGES": "Mensagens"
    },
    "DRAWER": {
      "TITLE": "Nova importação",
      "SOURCE": "fonte",
      "NAME": "Nome da importação",
      "NAME_PLACEHOLDER": "Migração Intercom Julho",
      "ACCESS_KEY": "Chave de acesso Intercom",
      "ACCESS_KEY_PLACEHOLDER": "Cole sua chave de acesso Intercom",
      "DATA_TYPES": "Dados para importar",
      "VALIDATING": "Validando chave de acesso...",
      "VALID_KEY": "Chave de acesso validada.",
      "INVALID_KEY": "Não foi possível validar esta chave de acesso.",
      "ACTIVE_IMPORT": "Espere a importação ativa terminar antes de iniciar outra.",
      "CANCEL": "Cancelar",
      "IMPORT": "Importar"
    },
    "EXPORT": {
      "TITLE": "As exportações estão a caminho",
      "DESCRIPTION": "Exporte seus contatos e conversas para fora desta conta. Este fluxo de trabalho estará disponível em breve.",
      "COMING_SOON": "Em breve"
    },
    "TABLE": {
      "TITLE": "Importações recentes",
      "EMPTY": "Nenhuma importação ainda",
      "EMPTY_DESCRIPTION": "Inicie uma importação para trazer o histórico de clientes existente para esta conta.",
      "NEW_IMPORT": "Importar",
      "COUNT": "Importações {count}",
      "UNNAMED": "Importação sem título",
      "IMPORTED_COUNT": "{count} importados",
      "VIEW": "Ver importação",
      "NAME": "Nome",
      "TYPE": "Tipo",
      "STATUS": "Status",
      "IMPORTED": "Importado",
      "CREATED": "Criado",
      "ABANDON": "Descartar"
    },
    "DETAIL": {
      "BACK": "Voltar às importações",
      "ERRORS": "Erros",
      "SKIP_LOGS": "Pular registros",
      "SOURCE": "fonte",
      "IMPORT_TYPES": "Tipos de importação",
      "CREATED": "Criado",
      "DURATION": "Duração",
      "INITIATED_BY": "Iniciado por",
      "PROGRESS": "Importar progresso",
      "PROGRESS_WITH_TOTAL": "{imported} de {total} importados",
      "PROGRESS_WITHOUT_TOTAL": "{imported} importados",
      "PROGRESS_OF_TOTAL": "de {total} importadas",
      "PROGRESS_IMPORTED": "importado",
      "LAST_UPDATED_TOOLTIP": "Última atualização em {time}",
      "NO_SKIP_LOGS": "Nenhum registro foi ignorado ou com falha registrado.",
      "DOWNLOAD_SKIP_LOGS": "Baixar CSV",
      "DOWNLOAD_ERROR_LOGS": "Baixar CSV",
      "ALL_SKIP_LOGS": "Todos",
      "KIND": "Tipo",
      "NO_ERRORS": "Nenhum erro registrado.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Objeto de origem",
      "MESSAGE": "Mensagem"
    },
    "MONITOR": {
      "LIVE": "Atualizações ao vivo a cada {seconds}s",
      "LAST_UPDATED": "Última atualização em {time}",
      "REFRESH": "Atualizar",
      "REFRESHING": "Atualizando",
      "STAGES": {
        "unknown": "Aguardando atualização",
        "queued": "Enfileirado",
        "contacts": "Importando contatos",
        "conversations": "Importando conversas",
        "finalizing": "Finalizando a importação",
        "completed": "Concluído",
        "completed_with_errors": "Concluído com erros",
        "failed": "Falha",
        "abandoned": "Abandonado"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Importação Intercom iniciada.",
      "IMPORT_ABANDONED": "A importação de Intercom foi abandonada.",
      "IMPORT_FAILED": "Não foi possível iniciar a importação de Intercom."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Configurações do Capitão",
    "DESCRIPTION": "Configure seus modelos e recursos de IA para o Capitão. O Capitão utiliza um modelo de cobrança baseado em créditos; você será cobrado em créditos por cada ação que o Capitão realizar, dependendo do modelo selecionado.",
    "LOADING": "Carregando configurações do Capitão...",
    "LINK_TEXT": "Saiba mais sobre os Créditos do Capitão",
    "NOT_ENABLED": "O Capitão não está habilitado para a sua conta. Atualize seu plano para acessar os recursos do Capitão.",
    "MODEL_CONFIG": {
      "TITLE": "Configuração do Modelo",
      "DESCRIPTION": "Selecione modelos de IA para diferentes recursos.",
      "SELECT_MODEL": "Selecionar modelo",
      "CREDITS_PER_MESSAGE": "{credits} crédito/mensagem",
      "COMING_SOON": "Em breve",
      "EDITOR": {
        "TITLE": "Recursos do Editor",
        "DESCRIPTION": "Potencializa a escrita inteligente, correções gramaticais, ajustes de tom e aprimoramento de conteúdo no editor de mensagens."
      },
      "ASSISTANT": {
        "TITLE": "Assistente",
        "DESCRIPTION": "Gerencia respostas automatizadas, resumos de conversas e sugestões inteligentes de resposta para interações com clientes."
      },
      "COPILOT": {
        "TITLE": "Copiloto",
        "DESCRIPTION": "Fornece sugestões contextuais em tempo real, recomendações da base de conhecimento e insights proativos durante as conversas."
      }
    },
    "FEATURES": {
      "TITLE": "Funcionalidades",
      "DESCRIPTION": "Ative ou desative recursos com tecnologia de IA.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcrição de Áudio",
        "DESCRIPTION": "Converte automaticamente mensagens de voz e gravações de chamadas em transcrições de texto pesquisáveis.",
        "MODEL_TITLE": "Modelo de transcrição de áudio",
        "MODEL_DESCRIPTION": "Selecione o modelo de IA a ser usado para converter mensagens de áudio em transcrições de texto"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Indexação de Pesquisa da Central de Ajuda",
        "DESCRIPTION": "Use IA para realizar buscas com reconhecimento de contexto nos artigos da sua central de ajuda."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Sugestão de Etiquetas",
        "DESCRIPTION": "Sugere automaticamente rótulos e etiquetas relevantes para as conversas, com base na análise de conteúdo e no contexto.",
        "MODEL_TITLE": "Modelo de Sugestão de Etiquetas",
        "MODEL_DESCRIPTION": "Selecione o modelo de IA a ser utilizado para analisar as conversas e sugerir etiquetas apropriadas"
      }
    },
    "API": {
      "SUCCESS": "Configurações do Capitão atualizadas com sucesso.",
      "ERROR": "Falha ao atualizar as configurações do Capitão. Por favor, tente novamente."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Cobrança",
    "DESCRIPTION": "Gerencie sua assinatura aqui, faça o upgrade do seu plano e obtenha mais para seu time.",
    "CURRENT_PLAN": {
      "TITLE": "Plano Atual",
      "PLAN_NOTE": "Você está atualmente inscrito no plano **{plan}** com **{quantity}** licenças",
      "SEAT_COUNT": "Número de assentos",
      "RENEWS_ON": "Renovações em",
      "CURRENCY": "moeda"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Escolha sua moeda de faturamento",
        "DESCRIPTION": "Selecione a moeda na qual você gostaria de ser cobrado. Isso não poderá ser alterado depois que sua assinatura for criada."
      },
      "OPTIONS": {
        "USD": "Dólar Americano (USD)",
        "BRL": "Real Brasileiro (BRL)"
      }
    },
    "VIEW_PRICING": "Ver Preços",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Gerencie sua assinatura",
      "DESCRIPTION": "Veja suas faturas anteriores, edite seus detalhes de cobrança, ou cancele sua assinatura.",
      "BUTTON_TXT": "Ir para o portal de cobrança"
    },
    "CAPTAIN": {
      "TITLE": "Capitão",
      "DESCRIPTION": "Gerenciar uso e créditos para o Captain AI.",
      "BUTTON_TXT": "Comprar mais créditos",
      "DOCUMENTS": "Documentos",
      "RESPONSES": "Respostas",
      "UPGRADE": "O capitão não está disponível no plano gratuito, faça o upgrade para ter acesso aos assistentes, co-piloto e muito mais.",
      "REFRESH_CREDITS": "Atualizar"
    },
    "CHAT_WITH_US": {
      "TITLE": "Precisa de ajuda?",
      "DESCRIPTION": "Você está com algum problema de cobrança? Nós estamos aqui para ajudar.",
      "BUTTON_TXT": "Fale conosco no chat"
    },
    "NO_BILLING_USER": "A sua conta de cobrança está sendo configurada. Atualize a página e tente novamente.",
    "TOPUP": {
      "BUY_CREDITS": "Comprar mais créditos",
      "MODAL_TITLE": "Comprar Créditos de IA",
      "MODAL_DESCRIPTION": "Comprar créditos adicionais para o Capitão IA.",
      "CREDITS": "CRÉDITOS",
      "ONE_TIME": "único",
      "POPULAR": "Mais populares",
      "NOTE_TITLE": "Nota:",
      "NOTE_DESCRIPTION": "Créditos são adicionados imediatamente e expiram em 6 meses. Uma assinatura ativa é necessária para usar créditos. Créditos adquiridos são consumidos após seus créditos do plano mensal.",
      "CANCEL": "Cancelar",
      "PURCHASE": "Comprar Créditos",
      "LOADING": "Carregando opções...",
      "FETCH_ERROR": "Falha ao carregar opções de crédito. Por favor, tente novamente.",
      "RETRY": "Tentar novamente",
      "PURCHASE_ERROR": "Falha ao processar a compra. Por favor, tente novamente.",
      "PURCHASE_SUCCESS": "Foram adicionados {credits} créditos com sucesso à sua conta",
      "CONFIRM": {
        "TITLE": "Confirmar Compra",
        "DESCRIPTION": "Você está prestes a comprar {credits} créditos por {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Seu cartão salvo será cobrado imediatamente após a confirmação.",
        "GO_BACK": "Voltar",
        "CONFIRM_PURCHASE": "Confirmar Compra"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Segurança",
    "DESCRIPTION": "Gerencie as configurações de segurança da sua conta.",
    "LINK_TEXT": "Saiba mais sobre o SAML SSO",
    "SAML_DISABLED_MESSAGE": "O SSO via SAML está desativado no momento. Entre em contato com o administrador para habilitar esse recurso.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure o login único via SAML para sua conta. Os usuários se autenticarão por meio do seu provedor de identidade em vez de usar e-mail e senha.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "URL do Assertion Consumer Service - Configure esta URL no seu IdP como o destino para as respostas SAML"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "A URL para onde as solicitações de autenticação SAML serão enviadas",
        "PLACEHOLDER": "https://sso.example.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Certificado de assinatura no formato PEM",
        "HELP": "O certificado público do seu provedor de identidade, usado para verificar as respostas SAML",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Impressão digital",
        "TOOLTIP": "Impressão digital SHA-1 do certificado - use-a para verificar o certificado na configuração do seu IdP"
      },
      "COPY_SUCCESS": "Código copiado para área de transferência com sucesso",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Identificador exclusivo desta aplicação como provedor de serviço (gerado automaticamente).",
        "TOOLTIP": "Identificador exclusivo do Chatwoot como Provedor de Serviço - configure-o nas configurações do seu IdP"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "ID da Entidade do Provedor de Identidade",
        "HELP": "Identificador exclusivo do seu provedor de identidade (geralmente encontrado na configuração do IdP)",
        "PLACEHOLDER": "https://sso.example.com/saml"
      },
      "UPDATE_BUTTON": "Atualizar configurações de SAML",
      "API": {
        "SUCCESS": "Configurações de SAML atualizadas com sucesso",
        "ERROR": "Falha ao atualizar as configurações de SAML",
        "ERROR_LOADING": "Falha ao carregar as configurações de SAML",
        "DISABLED": "Configurações de SAML desativadas com sucesso"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "A URL de SSO, o ID da Entidade do Provedor de Identidade e o Certificado são campos obrigatórios",
        "SSO_URL_ERROR": "Por favor, insira uma URL de SSO válida",
        "CERTIFICATE_ERROR": "O certificado é necessário",
        "IDP_ENTITY_ID_ERROR": "O ID da Entidade do Provedor de Identidade é obrigatório"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "O recurso de SSO via SAML está disponível apenas nos planos Enterprise.",
        "UPGRADE_PROMPT": "Atualize para um plano Enterprise para ter acesso ao login único via SAML e outros recursos avançados de segurança.",
        "ASK_ADMIN": "Entre em contato com seu administrador para fazer a atualização."
      },
      "PAYWALL": {
        "TITLE": "Atualizar para habilitar o SSO via SAML",
        "AVAILABLE_ON": "O recurso de SSO via SAML está disponível apenas nos planos Enterprise.",
        "UPGRADE_PROMPT": "Atualize seu plano para ter acesso ao login único via SAML e outros recursos avançados.",
        "UPGRADE_NOW": "Atualizar agora",
        "CANCEL_ANYTIME": "Você pode alterar ou cancelar seu plano a qualquer momento"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "Configuração de Atributos SAML",
        "DESCRIPTION": "Os seguintes mapeamentos de atributos devem ser configurados no seu provedor de identidade"
      },
      "INFO_SECTION": {
        "TITLE": "Informações do Provedor de Serviço",
        "TOOLTIP": "Copie esses valores e configure-os no seu Provedor de Identidade para estabelecer a conexão SAML"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Fluxos de Conversa",
        "DESCRIPTION": "Configure regras e campos obrigatórios para a resolução de conversas."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Atributos obrigatórios para resolução",
      "DESCRIPTION": "Ao resolver uma conversa, os agentes serão solicitados a preencher esses atributos caso ainda não o tenham feito.",
      "NO_ATTRIBUTES": "Nenhum atributo adicionado ainda",
      "ADD": {
        "TITLE": "Adicionar Atributos",
        "SEARCH_PLACEHOLDER": "Pesquisar atributos"
      },
      "SAVE": {
        "SUCCESS": "Atributos obrigatórios atualizados",
        "ERROR": "Não foi possível atualizar os atributos obrigatórios. Por favor, tente novamente"
      },
      "MODAL": {
        "TITLE": "Resolver conversa",
        "DESCRIPTION": "Por favor, preencha os seguintes atributos personalizados antes de resolver esta conversa",
        "ACTIONS": {
          "RESOLVE": "Resolver conversa",
          "CANCEL": "Cancelar"
        },
        "PLACEHOLDERS": {
          "TEXT": "Escreva uma nota...",
          "NUMBER": "Insira um número",
          "LINK": "Adicione um link",
          "DATE": "Selecione uma data",
          "LIST": "Selecione uma opção"
        },
        "CHECKBOX": {
          "YES": "Sim",
          "NO": "Não"
        }
      },
      "PAYWALL": {
        "TITLE": "Atualize para usar os atributos obrigatórios",
        "AVAILABLE_ON": "O recurso de atributos obrigatórios da conversa está disponível nos planos Business e Enterprise.",
        "UPGRADE_PROMPT": "Atualize seu plano para solicitar que os agentes preencham os atributos obrigatórios antes da resolução da conversa.",
        "UPGRADE_NOW": "Atualizar agora",
        "CANCEL_ANYTIME": "Você pode alterar ou cancelar seu plano a qualquer momento"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "O recurso de atributos obrigatórios de conversa está disponível nos planos pagos.",
        "UPGRADE_PROMPT": "Atualize para um plano pago para exigir atributos obrigatórios antes da resolução da conversa.",
        "ASK_ADMIN": "Entre em contato com seu administrador para fazer a atualização."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ah oh! Não conseguimos encontrar nenhuma conta. Por favor, crie uma nova conta para continuar.",
    "NEW_ACCOUNT": "Nova conta",
    "SELECTOR_SUBTITLE": "Criar nova conta",
    "API": {
      "SUCCESS_MESSAGE": "Conta criada com sucesso",
      "EXIST_MESSAGE": "Esta conta já existe",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor tente novamente mais tarde"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome da empresa",
        "PLACEHOLDER": "Informe o nome da conta"
      },
      "SUBMIT": "Enviar",
      "CANCEL": "Cancelar"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Alternar Modal",
    "TITLE": {
      "OPEN_CONVERSATION": "Abrir conversa",
      "RESOLVE_AND_NEXT": "Resolver e ir para o próximo",
      "NAVIGATE_DROPDOWN": "Navegar pelos itens suspensos",
      "RESOLVE_CONVERSATION": "Resolver Conversa",
      "GO_TO_CONVERSATION_DASHBOARD": "Ir para Painel de Conversação",
      "ADD_ATTACHMENT": "Adicionar anexo",
      "GO_TO_CONTACTS_DASHBOARD": "Ir para Painel de Contatos",
      "TOGGLE_SIDEBAR": "Alternar barra lateral",
      "GO_TO_REPORTS_SIDEBAR": "Ir para a barra lateral de Relatórios",
      "MOVE_TO_NEXT_TAB": "Mover para a próxima aba da lista de conversas",
      "GO_TO_SETTINGS": "Ir para Configurações",
      "SWITCH_TO_PRIVATE_NOTE": "Mudar para Nota Privada",
      "SWITCH_TO_REPLY": "Mudar para resposta",
      "TOGGLE_SNOOZE_DROPDOWN": "Ativar/desativar soneca"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Atribuição de agentes",
        "DESCRIPTION": "Defina políticas para gerenciar a carga de trabalho de forma eficaz e encaminhar conversas com base nas necessidades das caixas de entrada e dos agentes. Saiba mais aqui"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Política de atribuição",
        "DESCRIPTION": "Gerencie como as conversas são atribuídas nas caixas de entrada.",
        "FEATURES": [
          "Atribuir conversas de forma uniforme ou com base na capacidade disponível",
          "Adicione regras de distribuição justa para evitar sobrecarregar qualquer agente",
          "Adicione caixas de entrada a uma política - uma política por caixa de entrada"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Política de capacidade dos agentes",
        "DESCRIPTION": "Gerencie a carga de trabalho dos agentes.",
        "FEATURES": [
          "Defina o número máximo de conversas por caixa de entrada",
          "Criar exceções com base em rótulos e tempo",
          "Adicione agentes a uma política - uma política por agente"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Política de atribuição",
          "CREATE_POLICY": "Nova política"
        },
        "CARD": {
          "ORDER": "Ordem",
          "PRIORITY": "Prioridade",
          "ACTIVE": "Ativo",
          "INACTIVE": "Inativa",
          "POPOVER": "Caixas de entrada adicionadas",
          "EDIT": "Alterar"
        },
        "NO_RECORDS_FOUND": "Nenhuma política de atribuição encontrada"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Criar política de atribuição"
        },
        "CREATE_BUTTON": "Criar política",
        "API": {
          "SUCCESS_MESSAGE": "Política de atribuição criada com sucesso",
          "ERROR_MESSAGE": "Falha ao criar a política de atribuição",
          "INBOX_LINKED": "A caixa de entrada foi vinculada à política"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Editar política de atribuição"
        },
        "EDIT_BUTTON": "Atualizar política",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Adicionar caixa de entrada",
          "DESCRIPTION": "A caixa de entrada {inboxName} já está vinculada a outra política. Tem certeza de que deseja vinculá-la a esta política? Ela será desvinculada da outra.",
          "CONFIRM_BUTTON_LABEL": "Continuar",
          "CANCEL_BUTTON_LABEL": "Cancelar"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Vincular caixa de entrada à política",
          "DESCRIPTION": "Deseja vincular esta caixa de entrada à política de atribuição?",
          "LINK_BUTTON": "Vincular caixa de entrada",
          "CANCEL_BUTTON": "Pular"
        },
        "API": {
          "SUCCESS_MESSAGE": "Política de atribuição atualizada com sucesso",
          "ERROR_MESSAGE": "Falha ao atualizar a política de atribuição"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Caixa de entrada adicionada à política com sucesso",
            "ERROR_MESSAGE": "Falha ao adicionar a caixa de entrada à política"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Caixa de entrada removida da política com sucesso",
            "ERROR_MESSAGE": "Caixa de entrada removida da política com sucesso"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Nome da política:",
          "PLACEHOLDER": "Informe o nome da política"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição:",
          "PLACEHOLDER": "Insira a descrição"
        },
        "STATUS": {
          "LABEL": "Status:",
          "PLACEHOLDER": "Selecionar status",
          "ACTIVE": "Política ativa",
          "INACTIVE": "Política inativa"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Ordem de atribuição",
          "ROUND_ROBIN": {
            "LABEL": "Rodízio",
            "DESCRIPTION": "Distribuir as conversas de forma uniforme entre os agentes."
          },
          "BALANCED": {
            "LABEL": "Equilibrado",
            "DESCRIPTION": "Atribuir conversas com base na capacidade disponível.",
            "PREMIUM_MESSAGE": "Atualize o plano para acessar a atribuição equilibrada e o gerenciamento de capacidade dos agentes.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Prioridade de atribuição",
          "EARLIEST_CREATED": {
            "LABEL": "Criado recentemente",
            "DESCRIPTION": "A conversa criada primeiro será atribuída primeiro."
          },
          "LONGEST_WAITING": {
            "LABEL": "Maior tempo de espera",
            "DESCRIPTION": "A conversa que está aguardando há mais tempo é atribuída primeiro."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Política de distribuição justa",
          "DESCRIPTION": "Defina o número máximo de conversas que podem ser atribuídas por agente dentro de um período, para evitar sobrecarregar qualquer agente. Este campo obrigatório tem como padrão 100 conversas por hora.",
          "INPUT_MAX": "Máximo de atribuições",
          "DURATION": "Conversas por agente a cada"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Pular conversas obsoletas",
          "DESCRIPTION": "Pular conversas não atribuídas mais antigas. O padrão é 7 dias; limpar para desativar."
        },
        "INBOXES": {
          "LABEL": "Caixas de entrada adicionadas",
          "DESCRIPTION": "Adicionar caixas de entrada às quais esta política será aplicada.",
          "ADD_BUTTON": "Adicionar caixa de entrada",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Pesquisar e selecionar caixas de entrada para adicionar",
            "ADD_BUTTON": "Adicionar"
          },
          "EMPTY_STATE": "Nenhuma caixa de entrada adicionada a esta política. Adicione uma caixa de entrada para começar",
          "API": {
            "SUCCESS_MESSAGE": "Caixa de entrada adicionada à política com sucesso",
            "ERROR_MESSAGE": "Falha ao adicionar a caixa de entrada à política"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Política de atribuição excluída com sucesso",
        "ERROR_MESSAGE": "Falha ao excluir a política de atribuição"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Capacidade do agente",
          "CREATE_POLICY": "Nova política"
        },
        "CARD": {
          "POPOVER": "Agentes adicionados",
          "EDIT": "Alterar"
        },
        "NO_RECORDS_FOUND": "Nenhuma política de capacidade dos agentes encontrada"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Criar política de capacidade dos agentes"
        },
        "CREATE_BUTTON": "Criar política",
        "API": {
          "SUCCESS_MESSAGE": "Política de capacidade dos agentes criada com sucesso",
          "ERROR_MESSAGE": "Falha ao criar a política de capacidade dos agentes"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Editar política de capacidade dos agentes"
        },
        "EDIT_BUTTON": "Atualizar política",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Adicionar agente",
          "DESCRIPTION": "{agentName} já está vinculado a outra política. Tem certeza de que deseja vinculá-lo a esta política? Ele será desvinculado da outra.",
          "CONFIRM_BUTTON_LABEL": "Continuar",
          "CANCEL_BUTTON_LABEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Política de capacidade dos agentes atualizada com sucesso",
          "ERROR_MESSAGE": "Falha ao atualizar a política de capacidade dos agentes"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agente adicionado à política com sucesso",
            "ERROR_MESSAGE": "Falha ao adicionar o agente à política"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agente removido da política com sucesso",
            "ERROR_MESSAGE": "Falha ao remover o agente da política"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Limite de caixa de entrada adicionado com sucesso",
            "ERROR_MESSAGE": "Falha ao adicionar limite de caixa de entrada"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Limite de caixa de entrada atualizado com sucesso",
            "ERROR_MESSAGE": "Falha ao atualizar limite da caixa de entrada"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Limite da caixa de entrada excluído com sucesso",
            "ERROR_MESSAGE": "Falha ao excluir o limite da caixa de entrada"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Nome da política:",
          "PLACEHOLDER": "Informe o nome da política"
        },
        "DESCRIPTION": {
          "LABEL": "Descrição:",
          "PLACEHOLDER": "Insira a descrição"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Limites de capacidade da caixa de entrada",
          "ADD_BUTTON": "Adicionar caixa de entrada",
          "FIELD": {
            "SELECT_INBOX": "Selecionar caixa de entrada",
            "MAX_CONVERSATIONS": "Máximo de conversas",
            "SET_LIMIT": "Definir limite"
          },
          "EMPTY_STATE": "Nenhum limite de caixa de entrada definido"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Regras de exclusão",
          "DESCRIPTION": "Conversas que atendam às seguintes condições não serão contabilizadas na capacidade do agente",
          "TAGS": {
            "LABEL": "Excluir conversas marcadas com rótulos específicos",
            "ADD_TAG": "adicionar etiqueta",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Pesquise e selecione etiquetas para adicionar"
            },
            "EMPTY_STATE": "Nenhuma etiqueta adicionada a esta política."
          },
          "DURATION": {
            "LABEL": "Excluir conversas mais antigas que um período especificado",
            "PLACEHOLDER": "Definir duração"
          }
        },
        "USERS": {
          "LABEL": "Agentes atribuídos",
          "DESCRIPTION": "Adicione os agentes aos quais esta política será aplicada.",
          "ADD_BUTTON": "Adicionar agente",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Pesquise e selecione agentes para adicionar",
            "ADD_BUTTON": "Adicionar"
          },
          "EMPTY_STATE": "Nenhum agente adicionado",
          "API": {
            "SUCCESS_MESSAGE": "Agente adicionado à política com sucesso",
            "ERROR_MESSAGE": "Falha ao adicionar o agente à política"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Política de capacidade de agentes excluída com sucesso",
        "ERROR_MESSAGE": "Falha ao excluir a política de capacidade de agentes"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Excluir política",
      "DESCRIPTION": "Tem certeza de que deseja excluir esta política? Essa ação não pode ser desfeita.",
      "CONFIRM_BUTTON_LABEL": "Excluir",
      "CANCEL_BUTTON_LABEL": "Cancelar"
    }
  }
}
